exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_bckImg_2LksI {\n  position: relative;\n  width: 100%;\n  height: inherit;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-origin: content-box;\n}\n\n.index_bckImg_2LksI img {\n  position: relative;\n  opacity: 0;\n  z-index: -1;\n  max-width: 100%;\n}\n", ""]);

// Exports
exports.locals = {
	"bckImg": "index_bckImg_2LksI"
};